import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const customConfig = defineConfig({
  globalCss: {
    "::selection": {
      backgroundColor: "#329A9A",
      color: "white",
    },
  },
  theme: {
    tokens: {
      fonts: {
        heading: { value: `'Figtree', sans-serif` },
        body: { value: `'Figtree', sans-serif` },
      },
      colors: {
        brand: {
          50: { value: "#ECF9F9" },
          100: { value: "#C9EEEE" },
          200: { value: "#A6E3E3" },
          300: { value: "#83D7D7" },
          400: { value: "#61CCCC" },
          500: { value: "#3EC1C1" },
          600: { value: "#329A9A" },
          700: { value: "#257474" },
          800: { value: "#194D4D" },
          900: { value: "#0C2727" },
          950: { value: "#0C2727" },
        },
        gray: {
          50: { value: "#f9f9f9" },
          100: { value: "#ededed" },
          200: { value: "#d3d3d3" },
          300: { value: "#b3b3b3" },
          400: { value: "#a0a0a0" },
          500: { value: "#898989" },
          600: { value: "#444444" },
          700: { value: "#202020" },
          800: { value: "#171717" },
          900: { value: "#111" },
          950: { value: "#0A0A0A" },
        },
      },
    },
    semanticTokens: {
      colors: {
        brand: {
          solid: { value: "{colors.brand.500}" },
          contrast: { value: "{colors.brand.100}" },
          fg: { value: "{colors.brand.700}" },
          muted: { value: "{colors.brand.100}" },
          subtle: { value: "{colors.brand.200}" },
          emphasized: { value: "{colors.brand.300}" },
          focusRing: { value: "{colors.brand.500}" },
        },
      },
    },
  },
});

export const system = createSystem(defaultConfig, customConfig);
